// extracted by mini-css-extract-plugin
export default {"box":"Hello_box__3FAwL","top":"Hello_top__yBrgx"};